import {
  Outlet,
  Link,
  useLoaderData,
  useParams,
  NavLink
} from "react-router-dom";

import { useState, useEffect } from "react";
import * as API from "../services/vismedicas";
import { FormatDate } from "../components/documentacion/FormatDate";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getAllVismedicasByTax(params.tratamientoId);
}

export function VismedicasList(props) {
  const [vismedicasList, setVismedicas] = useState([]);
  let { tratamientoId } = useParams();

  useEffect(() => {
    API.getAllVismedicasByTax(props.id).then(setVismedicas).catch(console.log);
  }, [props.id]);
  return (
    <>
      {vismedicasList?.length ? (
        <ul className="vismedicas cpt-list">
            {vismedicasList
              .sort((a, b) => {
                // Convertir las fechas a objetos de fecha para comparar
                const dateA = new Date(`${a.meta.metaFecha}T${a.meta.vismedHora}:00`);
                const dateB = new Date(`${b.meta.metaFecha}T${b.meta.vismedHora}:00`);

                // Ordenar de manera descendente (más reciente primero)
                return dateB - dateA;
              })
              .map((vismedicas) => (
                <li key={vismedicas.id}>
                  <NavLink to={`${props.id}/hospitalizacion/visitas-medicas/${vismedicas.id}`}>{`${FormatDate(vismedicas?.meta?.metaFecha)}`}</NavLink>
                </li>
              ))}
            </ul>
          ) : (
            <></>
          )}
    </>
  );
}



export function VismedicasListContent(props) {
  let { tratamientoId } = useParams();
  console.log(tratamientoId);
  return (
    <>
      <div id="content">
        <h1>Visitas Médicas</h1>
      </div>
      <div id="actions">
      {(props.userRole.includes('administrador') || props.userRole.includes('medicina')) && (
        <Link className="button is-link" to={`new`}>Nuevo</Link>
      )}
      </div>
    </>
  );
}